import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { parse } from "@babel/parser";
import { parseModule } from "./parseModule.js";
export function parseFile(filePath, app, ast, options) {
  var _ast;
  var file = app.files.find(function (f) {
    return f.filePath === filePath;
  });
  if (!file) {
    throw new Error("File not found: ".concat(filePath));
  }
  if (app.modules.has(filePath)) {
    return;
  }
  app.modules.set(filePath, null);
  var isScript = filePath.endsWith(".ts") || filePath.endsWith(".tsx");
  var isCss = !isScript && file.filePath.endsWith(".css");
  if (!ast && isScript) {
    try {
      ast = parse(file.content, {
        plugins: ["jsx", "typescript"],
        sourceType: "module",
        errorRecovery: true
      });
    } catch (error) {
      app.errors.push({
        message: "Failed to parse file (".concat(filePath, "): ").concat(error),
        node: null,
        severity: "fatal",
        filePath: filePath
      });
      return;
    }
  }
  var isEntry = !app.entry;
  var moduleType = isEntry ? "entry" : isCss ? "css" : !isScript ? "unknown" : file.filePath.startsWith("/Pages/") ? "page" : file.filePath.startsWith("/Components/") ? "template" : file.filePath.startsWith("/Utils/") ? "function" : "unknown";
  var mod = {
    source: file.content,
    filePath: filePath,
    moduleType: moduleType,
    defaultExport: null,
    namedExports: new Map(),
    internals: [],
    errors: [],
    contracts: new Set(),
    usedHelpers: new Set()
  };
  if ((_ast = ast) !== null && _ast !== void 0 && (_ast = _ast.errors) !== null && _ast !== void 0 && _ast.length) {
    var _iterator = _createForOfIteratorHelper(ast.errors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var error = _step.value;
        mod.errors.push({
          message: "".concat(error.code, ": ").concat(error.reasonCode),
          node: null,
          severity: "error"
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  if (isEntry) {
    app.entry = mod;
  }
  app.modules.set(filePath, mod);
  if (ast) {
    parseModule(mod, app, ast, options);
  } else if (isCss) {
    app.constants.set(filePath, file.content);
  }
}
//# sourceMappingURL=parseFile.js.map